import { useEffect, useCallback } from "react";
import axiosInstance from "../services/axios";
import { API_ENDPOINTS } from "../constants/api";

/**
 * Hook to periodically check server connectivity
 * @param interval - Check interval in milliseconds (default: 30000ms)
 * @param enabled - Whether to enable the connectivity check (default: true)
 */
export const useServerConnectivityCheck = (
  interval: number = 1000000, // Default interval is 300,000ms (5 MIN)
  enabled: boolean = true,
) => {
  const checkConnectivity = useCallback(async () => {
    if (!enabled || !navigator.onLine) return;

    try {
      // Try to make a simple request to check server connectivity
      // Using a timeout to avoid long waits
      await axiosInstance.get(API_ENDPOINTS.HEALTH, {
        headers: { "x-connectivity-check": "true" },
      });
    } catch (error) {
      // Error will be handled by axios interceptors
      console.debug("Server connectivity check failed:", error);
    }
  }, [enabled]);

  useEffect(() => {
    if (!enabled) return;

    // Initial check
    checkConnectivity();

    // Set up periodic checks
    // const intervalId = setInterval(checkConnectivity, interval);

    // return () => clearInterval(intervalId);
  }, [checkConnectivity, interval, enabled]);

  return { checkConnectivity };
};
